export const langListMap = {
  af: 'langList.afrikaans',
  ar: 'langList.ar',
  az: 'langList.az',
  be: 'langList.be',
  bg: 'langList.bg',
  ca: 'langList.ca',
  cs: 'langList.cs',
  cy: 'langList.cy',
  da: 'langList.da',
  de: 'langList.de',
  dv: 'langList.dv',
  el: 'langList.el',
  en: 'langList.en',
  en_US: 'langList.en_US',
  en_GB: 'langList.en_GB',
  eo: 'langList.eo',
  es: 'langList.es',
  et: 'langList.et',
  eu: 'langList.eu',
  fa: 'langList.fa',
  fi: 'langList.fi',
  fo: 'langList.fo',
  fr: 'langList.fr',
  gl: 'langList.gl',
  gu: 'langList.gu',
  he: 'langList.he',
  hi: 'langList.hi',
  hr: 'langList.hr',
  hu: 'langList.hu',
  hy: 'langList.hy',
  id: 'langList.id',
  is: 'langList.is',
  it: 'langList.it',
  ja: 'langList.ja',
  ka: 'langList.ka',
  kk: 'langList.kk',
  kn: 'langList.kn',
  ko: 'langList.ko',
  kok: 'langList.kok',
  ky: 'langList.ky',
  lt: 'langList.lt',
  lv: 'langList.lv',
  mi: 'langList.mi',
  mk: 'langList.mk',
  mn: 'langList.mn',
  mr: 'langList.mr',
  ms: 'langList.ms',
  mt: 'langList.mt',
  nb: 'langList.nb',
  nl: 'langList.nl',
  ns: 'langList.ns',
  pa: 'langList.pa',
  pl: 'langList.pl',
  pt: 'langList.pt',
  pt_BR: 'langList.pt_BR',
  qu: 'langList.qu',
  ro: 'langList.ro',
  ru: 'langList.ru',
  sa: 'langList.sa',
  se: 'langList.se',
  sk: 'langList.sk',
  sl: 'langList.sl',
  sq: 'langList.sq',
  sv: 'langList.sv',
  sw: 'langList.sw',
  syr: 'langList.syr',
  ta: 'langList.ta',
  te: 'langList.te',
  th: 'langList.th',
  tl: 'langList.tl',
  tn: 'langList.tn',
  tr: 'langList.tr',
  ts: 'langList.ts',
  tt: 'langList.tt',
  uk: 'langList.uk',
  ur: 'langList.ur',
  uz: 'langList.uz',
  vi: 'langList.vi',
  xh: 'langList.xh',
  zh: 'langList.zh',
  zh_CN: 'langList.zh_CN',
  zh_HK: 'langList.zh_HK',
  zh_TW: 'langList.zh_TW',
  zu: 'langList.zu'
};

export const downFileName = {
  menu: 'upload.menuFileName',
  standardPro: 'upload.allFileName',
  product: 'upload.productAllFileName',
  
  productName: 'upload.productName',

  productGroup: 'upload.productGroup',
  productFunction: 'upload.productFunction',
  categoryName: 'upload.categoryName',
  categoryGroup: 'upload.categoryGroup',
  categoryFunction: 'upload.categoryFunction'
};
